
jQuery(function($){

	if( $('.custom-lightbox').length ) {

		// When a lighbox trigger is clicked, open the relevant lightbox
		$("[data-lightbox]").on('click', function(event) {
			$("html").addClass('js-custom-lightbox-open');
			$($(this).data('lightbox')).addClass('js-is-open');
		});

		// When the close button or background overlay is clicked, close the lightbox
		$(".custom-lightbox__overlay, .custom-lightbox__close").on('click', function(event) {
			$("html").removeClass('js-custom-lightbox-open');
			$('.custom-lightbox').removeClass('js-is-open');
		});

		// When the ESC key is pressed, close the lightbox
		$(document).on('keydown', function(event) {
			if (event.key == "Escape") {
				$("html").removeClass('js-custom-lightbox-open');
				$('.custom-lightbox').removeClass('js-is-open');
			}
		});


	}

});





